import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  Modal,
  Row,
  Select,
  Space,
  Spin,
} from "antd";
import axios from "axios";

import React, { useEffect, useState } from "react";
import config from "../../../config";
import authHeader from "../../Authentication/authHeader";
import Swal from "sweetalert2";
import { PlusOutlined } from "@ant-design/icons";
import dayjs from "dayjs";

export default function TargetModal({
  visible,
  modalClose,
  data,
  isUpdate,
  userProfile,
  fetchTargetList,
  isView,
}) {
  const [form] = Form.useForm();
  const { Option } = Select;
  const [centerList, setCenterList] = useState([]);
  const [productList, setProductList] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [targetDetails, setTargetDetails] = useState([]);
  const [approveByUserList, setApprovedByUserList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);

  useEffect(() => {
    if (userProfile && !isUpdate) {
      form.setFieldsValue({
        prepared_by_user_id: userProfile?.employee_id,
      });
    }
  }, [userProfile, form, isUpdate]);

  useEffect(() => {
    if (data) {
      form.setFieldsValue({
        prepared_by_user_id: data?.prepared_by?.prepared_by_user_id,
        center_id: data?.center?.center_id,
        officer_name: data?.officer_name,
        total_target: data?.total_target,
        approved_by: data?.approved_by?.approved_by_user_id,
        status: data?.status,
        remarks: data?.remarks,
        category: data?.product?.category?.category_id,
        product_id: data?.product?.product_id,
        target_month: dayjs(data?.target_month, "MMMM YYYY"),
      });

      if (targetDetails && targetDetails.length > 0) {
        form.setFieldsValue({
          targets: targetDetails,
        });
      }
    }
  }, [data, targetDetails, form]);

  useEffect(() => {
    axios
      .get(`${config.baseUrl}/inventory/center_list/`, {
        headers: authHeader(),
      })
      .then((response) => {
        setCenterList(response?.data);
      })
      .catch((error) => {
        Swal.fire({
          title: "Error",
          text: error,
          confirmButtonText: "Ok",
          icon: "error",
        });
      });
  }, []);
  useEffect(() => {
    axios
      .get(`${config.baseUrl}/inventory/target_details/${data?.target_id}/`, {
        headers: authHeader(),
      })
      .then((response) => {
        setTargetDetails(response?.data);
      })
      .catch((error) => {
        Swal.fire({
          title: "Error",
          text: error,
          confirmButtonText: "Ok",
          icon: "error",
        });
      });
  }, [data?.target_id]);

  useEffect(() => {
    axios
      .get(`${config.baseUrl}/employee/sales_operations_users/`, {
        headers: authHeader(),
      })
      .then((response) => {
        setApprovedByUserList(response?.data);
      })
      .catch((error) => {
        Swal.fire({
          title: "Error",
          text: error,
          confirmButtonText: "Ok",
          icon: "error",
        });
      });
  }, []);

  useEffect(() => {
    axios
      .get(`${config.baseUrl}/inventory/category_list/`, {
        headers: authHeader(),
      })
      .then((response) => {
        setCategoryList(response?.data);
      })
      .catch((error) => {
        Swal.fire({
          title: "Error",
          text: error,
          confirmButtonText: "Ok",
          icon: "error",
        });
      });
  }, []);

  const handleCategorySelection = (value) => {
    setSelectedCategory(value);
  };

  const [selectedTypes, setSelectedTypes] = useState([]);

  const handleTypeSelect = (value, index) => {
    setSelectedTypes((prev) => [...prev, { index, value }]);
};

const handleTypeRemove = (index) => {
    setSelectedTypes((prev) => prev.filter((item) => item.index !== index));
};

const availableOptions = ["Daily", "Weekly", "Monthly"].filter(
    (type) => !selectedTypes.some((item) => item.value === type)
);

  const fetchProductList = () => {
    if (selectedCategory || data?.product?.category?.category_id) {
      setLoading(true);
      axios
        .get(`${config.baseUrl}/inventory/category_wise_product_list/`, {
          headers: authHeader(),
          params: {
            category: selectedCategory || data?.product?.category?.category_id,
          },
        })
        .then((response) => {
          setLoading(false);
          setProductList(response?.data);
        })
        .catch((error) => {
          setLoading(false);
          console.log(error);
          Swal.fire({
            title: "Error",
            text: error,
            confirmButtonText: "Ok",
            icon: "error",
          });
        });
    }
  };
  useEffect(() => {
    fetchProductList();
  }, [selectedCategory, data?.product?.category?.category_id]);

  const handleModalClose = () => {
    form.setFieldsValue({
      prepared_by_user_id: null,
      center_id: null,
      total_target: null,
      approved_by: null,
      status: null,
      remarks: null,
      expenses: [],
    });
    setProductList([]);
    setSelectedCategory(null);
    modalClose();
  };

  const handleTargetCreate = (value) => {
    setLoading(true);
    axios
      .post(`${config.baseUrl}/inventory/create_target/`, value, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response?.status === 201) {
          setLoading(false);
          Swal.fire({
            title: "Success",
            text: response?.data?.message,
            confirmButtonText: "Ok",
            icon: "success",
          }).then(() => {
            form.resetFields();
            modalClose();
            fetchTargetList();
          });
        }
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
        Swal.fire({
          title: "Error",
          text: error?.response?.data?.message,
          confirmButtonText: "Ok",
          icon: "error",
        });
      });
  };
  const handleTargetUpdate = (value) => {
    value.total_target = parseFloat(value.total_target);

    value.target_month = dayjs(value.target_month)
      .add(6, "hours")
      .format("YYYY-MM-01T00:00:00.000[Z]");
    setLoading(true);
    axios
      .patch(`${config.baseUrl}/inventory/update_target/${data?.target_id}/`, value, {
        headers: authHeader(),
      })
      .then((response) => {
        setLoading(false);
        if (response?.status === 200) {
          Swal.fire({
            title: "Success",
            text: "Target Updated Successfully",
            confirmButtonText: "Ok",
            icon: "success",
          }).then(() => {
            form.resetFields();
            modalClose();
            fetchTargetList();
          });
        }
      })
      .catch((error) => {
        setLoading(false);
        Swal.fire({
          title: "Error",
          text: error,
          confirmButtonText: "Ok",
          icon: "error",
        });
      });
  };

  return (
    <Modal
      title={
        isUpdate
          ? "Update Target"
          : isView
          ? "View Target Details"
          : "Add Target"
      }
      open={visible}
      onCancel={handleModalClose}
      footer={false}
      width="40%"
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={isUpdate ? handleTargetUpdate : handleTargetCreate}
      >
        <Form.Item label="Prepared By">
          <Input
            readOnly
            defaultValue={
              isUpdate
                ? data?.prepared_by?.prepared_by_name
                : userProfile?.first_name + " " + userProfile?.last_name
            }
          />
        </Form.Item>

        <Form.Item name="prepared_by_user_id" hidden>
          <Input
            value={
              isUpdate
                ? userProfile?.employee_id
                : data?.prepared_by?.prepared_by_user_id
            }
            readOnly
          />
        </Form.Item>
        <Form.Item
          label="Center"
          name="center_id"
          rules={[
            {
              required: true,
              message: "Center required!",
            },
          ]}
        >
          <Select
            placeholder="Select Center"
            allowClear
            showSearch
            disabled={
              isUpdate
                ? userProfile?.employee_id !==
                  data?.prepared_by?.prepared_by_user_id
                : isView
                ? true
                : false
            }
          >
            {centerList?.map((center) => (
              <Option key={center?.id} value={center?.center?.employee_id}>
                {center?.center_name}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          name="officer_name"
          label="Officer Name"
          rules={[
            {
              required: true,
              message: "Officer name required!",
            },
          ]}
        >
          <Input
            placeholder="Officer Name"
            disabled={
              isUpdate
                ? userProfile?.employee_id !==
                  data?.prepared_by?.prepared_by_user_id
                : isView
                ? true
                : false
            }
          />
        </Form.Item>
        <Row gutter={[8, 16, 24, 32]}>
          <Col xs={24} sm={12} md={12} lg={12}>
            <Form.Item
              label="Category"
              name="category"
              rules={[
                {
                  required: true,
                  message: "Category required!",
                },
              ]}
            >
              <Select
                placeholder="Select Category"
                allowClear
                showSearch
                onChange={handleCategorySelection}
                disabled={
                  isUpdate
                    ? userProfile?.employee_id !==
                      data?.prepared_by?.prepared_by_user_id
                    : isView
                    ? true
                    : false
                }
              >
                {categoryList?.map((category) => (
                  <Option
                    key={category?.category_id}
                    value={category?.category_id}
                  >
                    {category?.category_name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          <Col
            xs={24}
            sm={12}
            md={12}
            lg={12}
            hidden={selectedCategory || isUpdate ? false : true}
          >
            <Form.Item
              label="Product"
              name="product_id"
              rules={[
                {
                  required: true,
                  message: "Product required!",
                },
              ]}
            >
              <Select
                placeholder="Select product"
                allowClear
                showSearch
                disabled={
                  isUpdate
                    ? userProfile?.employee_id !==
                      data?.prepared_by?.prepared_by_user_id
                    : isView
                    ? true
                    : false
                }
              >
                {productList?.map((product) => (
                  <Option key={product?.product_id} value={product?.product_id}>
                    {product?.product_name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>

        <Form.Item
          name="target_month"
          label="Target Month"
          rules={[
            {
              required: true,
              message: "Target month required!",
            },
          ]}
        >
          <DatePicker
            placeholder="Target Month"
            picker="month"
            disabled={
              isUpdate
                ? userProfile?.employee_id !==
                  data?.prepared_by?.prepared_by_user_id
                : isView
                ? true
                : false
            }
          />
        </Form.Item>

        <Form.List name="targets" initialValue={[{}]}>
          {(fields, { add, remove }) => (
            <>
              <Col lg={4}>
                <Form.Item>
                  <Button
                    size="small"
                    type="default"
                    onClick={() => add()}
                    block
                    icon={<PlusOutlined />}
                    style={{ color: "#000000" }}
                    disabled={
                      isUpdate
                        ? userProfile?.employee_id !==
                          data?.prepared_by?.prepared_by_user_id
                        : isView
                        ? true
                        : false
                    }
                  >
                    Target
                  </Button>
                </Form.Item>
              </Col>
              {fields.map(({ key, name, ...restField }, index) => (
                <Space key={key} align="baseline">
                  <Row gutter={[8, 16, 24, 32]}>
                    <Col style={{ width: "380px" }}>
                      <Form.Item
                        {...restField}
                        name={[name, "target_type"]}
                        rules={[
                          {
                            required: true,
                            message: "Target type required!",
                          },
                        ]}
                      >
                        <Select
                          placeholder="Select Type"
                          allowClear
                          showSearch
                          onChange={(value) => handleTypeSelect(value, index)}
                          disabled={
                            isUpdate
                              ? userProfile?.employee_id !==
                                data?.prepared_by?.prepared_by_user_id
                              : isView
                              ? true
                              : false
                          }
                        >
                          {availableOptions.map((option) => (
                            <Option key={option} value={option}>
                              {option}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>

                    <Col style={{ width: "200px" }}>
                      <Form.Item
                        {...restField}
                        name={[name, `target_qty`]}
                        rules={[
                          {
                            required: true,
                            message: "Target required!",
                          },
                          {
                            pattern: /^[0-9]+$/,
                            message: "Only english numbers",
                          },
                        ]}
                      >
                        <Input
                          placeholder="Target Quantity"
                          inputMode="numeric"
                          disabled={
                            isUpdate
                              ? userProfile?.employee_id !==
                                data?.prepared_by?.prepared_by_user_id
                              : isView
                              ? true
                              : false
                          }
                        />
                      </Form.Item>
                    </Col>
                    <Col className="d-flex align-items-start">
                      {fields.length > 1 && (
                        <Button
                          className="pt-0 mt-0"
                          size="small"
                          disabled={
                            isUpdate
                              ? userProfile?.employee_id !==
                                data?.prepared_by?.prepared_by_user_id
                              : isView
                              ? true
                              : false
                          }
                          onClick={() => {
                            form.setFieldsValue({
                              total_target: undefined,
                            });
                            remove(name);
                            handleTypeRemove(index);
                          }}
                          style={{
                            backgroundColor: "",
                            color: "darkred",
                            borderColor: "darkred",
                          }}
                        >
                          x
                        </Button>
                      )}
                    </Col>
                  </Row>
                </Space>
              ))}
            </>
          )}
        </Form.List>

        <Form.Item
          label="Approved By"
          name="approved_by"
          rules={[
            {
              required: true,
              message: "Required!",
            },
          ]}
        >
          <Select
            placeholder="Select Approved By"
            disabled={
              isUpdate
                ? userProfile?.employee_id !==
                  data?.prepared_by?.prepared_by_user_id
                : isView
                ? true
                : false
            }
          >
            {approveByUserList?.map((user) => (
              <Option key={user?.employee_id} value={user?.employee_id}>
                {user?.user_info?.first_name + " " + user?.user_info?.last_name}
              </Option>
            ))}
          </Select>
        </Form.Item>
        {isUpdate &&
          userProfile?.employee_id ===
            data?.approved_by?.approved_by_user_id && (
            <Form.Item
              label="Status"
              name="status"
              rules={[
                {
                  required: true,
                  message: "Status required!",
                },
              ]}
            >
              <Select placeholder="Select Status">
                <Option value="Approved">Approved</Option>
              </Select>
            </Form.Item>
          )}
        <Form.Item label="Remarks" name="remarks">
          <Input
            placeholder="Remarks"
            disabled={
              isUpdate
                ? userProfile?.employee_id !==
                  data?.prepared_by?.prepared_by_user_id
                : isView
                ? true
                : false
            }
          />
        </Form.Item>
        <Form.Item hidden={isView ? true : false}>
          <Button
            style={{
              backgroundColor: "#46604A",
              borderColor: "#46604A",
              color: "white",
            }}
            htmlType="submit"
            onClick={() => console.log("sadasdad")}
          >
            {isUpdate ? "Update" : "Submit"}
            {loading && <Spin size="small" style={{ marginLeft: 8 }} />}
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
}
